/**
 * smartbanner.js initializes on script eval (before React) so it's very likely
 * our document event handler for the "view" will not be setup in time to be invoked
 *
 * this function can be called in module scope, and the returned object will hold
 * a reference to whether the event handler was invoked before the react component
 * that needs that event was mounted
 */
export const handleBeforeReactSmartBannerEvents = () => {
  const ref = { smartBannerViewBeforeReactReady: false };

  if (typeof document !== "undefined") {
    document.addEventListener("smartbanner.view", () => {
      ref.smartBannerViewBeforeReactReady = true;
    });
  }

  return ref;
};
